import Client, { IClientConfig } from './Client'
import ScClient from './ScClient'
import AuthHelper from './auth/AuthHelper'
import * as errors from './errors'
import Result from './helpers/Result'
import Http from './Http'
import * as routes from './routes'

const makeClient = (config: IClientConfig = {}) => new Client(config)

export {
  Client,
  Http,
  Result,
  errors,
  makeClient,
  routes,
  AuthHelper,
  ScClient,
}
